const $ = (e) => {
  const c = Object.getPrototypeOf(e), t = new c.constructor(e.message);
  return Object.assign(t, e), Object.setPrototypeOf(t, c), e.stack && (t.stack = e.stack), t;
}, i = (e) => {
  var f;
  const c = (e == null ? void 0 : e.context) ?? "", t = e.info ? e.info() : void 0, y = !!((f = e.devMode) != null && f.call(e));
  return { logger: {
    error: (o) => {
      let r;
      const n = ["message", "stack"];
      if (typeof o == "string")
        r = `${c} - ${o}`;
      else if (n.every((s) => Object.getOwnPropertyNames(o).includes(s)))
        r = $(o), r.message = `${c} - ${o.message}`;
      else {
        console.error(
          `Error Logger: Expected [string | Error] but received ${o} of type  ${typeof o}`
        );
        return;
      }
      e.adapters.forEach((s) => {
        var l;
        (l = s.error) == null || l.call(s, r, t);
      }), y && console.error(r, t);
    },
    warn: (o) => {
      if (typeof o == "string") {
        const r = `${c} - ${o}`;
        e.adapters.forEach((n) => {
          var s;
          (s = n.warn) == null || s.call(n, r, t);
        }), y && console.warn(r, t);
      } else
        console.error(
          `Error Logger: Expected [string] but received ${o} of type ${typeof o}`
        );
    },
    info: (o) => {
      if (typeof o == "string") {
        const r = `${c} - ${o}`;
        e.adapters.forEach((n) => {
          var s;
          (s = n.info) == null || s.call(n, r, t);
        }), y && console.info(r, t);
      } else
        console.error(
          `Error Logger: Expected [string] but received ${o} of type ${typeof o}`
        );
    }
  } };
};
export {
  i as loggerFactory
};
//# sourceMappingURL=loggerFactory.js.map
